/**
 * Ob ein Zugriffstoken vor dem Absenden aufzufrischen ist (HM-098) — die reine
 * Entscheidung, ohne Uhr und ohne Netz, damit sie ohne Browser geprüft ist.
 *
 * **Warum es diese Frage überhaupt gibt:** Die Sitzung frischt vorausschauend
 * über einen Timer auf. Ein Browser auf dem Telefon hält Timer an, sobald der
 * Tab in den Hintergrund geht; wer Stunden später zurückkehrt, hat einen
 * abgelaufenen Token im Speicher und ein gültiges Cookie — und die erste
 * Anfrage ging mit dem Token hinaus, bekam `401`, und die Anwendung schloss
 * daraus auf das Ende der Sitzung. Die Anmeldeseite stand da, obwohl ein
 * Neuladen sofort wieder hineinführte.
 */

/**
 * So lange vor Ablauf gilt ein Token als aufzufrischen. Eine Minute deckt eine
 * langsame Verbindung und eine ungenau gehende Uhr ab — dieselbe Frist wie
 * beim Timer.
 */
export const REFRESH_LEAD_MS = 60_000;

/** Ob der Token bis `expiresAt` nicht mehr trägt — abgelaufen oder kurz davor. */
export function needsRefresh(
  expiresAt: number,
  now: number,
  lead: number = REFRESH_LEAD_MS,
): boolean {
  return expiresAt - now <= lead;
}

/**
 * Die Auffrischung selbst darf nicht auf sich warten: Sie geht ohne Token
 * hinaus, der Browser hängt das Cookie an. Alles andere wartet.
 */
export function isRefreshRequest(url: string): boolean {
  return new URL(url, "http://localhost").pathname.endsWith("/auth/refresh");
}
